import { Typography, Badge } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { cn } from '@ui/utils';
import { FC } from 'react';

interface SubscriptionHeaderProps {
  isCurrent?: boolean;
  isLoading?: boolean;
  name?: string;
}

export const SubscriptionHeader: FC<SubscriptionHeaderProps> = ({ isCurrent, isLoading, name }) => {
  const { t } = useTranslation();

  return (
    <div className="h-20">
      <div className="flex items-center justify-between gap-5">
        <Typography
          className={cn('line-clamp-2', { 'text-disabled': isLoading })}
          variant="amountLarge"
        >
          {name}
        </Typography>
        {isCurrent && !isLoading && (
          <Badge className="whitespace-nowrap" variant="blue" size="large">
            {t('SUBSCRIPTIONS.CURRENT_PLAN')}
          </Badge>
        )}
      </div>
    </div>
  );
};
